import React, { useState } from 'react';
import './CustomerContents.css';

const CustomerContents = () => {
  const [formData, setFormData] = useState({
    linkUrl: ''
  });

  const [uploadedFiles, setUploadedFiles] = useState({
    image: null,
    video: null
  });

  const [dragActive, setDragActive] = useState({
    image: false,
    video: false
  });

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      linkUrl: e.target.value
    });
  };

  const handleFileUpload = (file, type) => {
    const maxSize = 100 * 1024 * 1024; // 100MB
    
    if (file.size > maxSize) {
      alert('파일 크기는 100MB를 초과할 수 없습니다.');
      return;
    }

    const allowedImageTypes = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const allowedVideoTypes = ['video/mp4', 'video/avi', 'video/mov'];

    if (type === 'image' && !allowedImageTypes.includes(file.type)) {
      alert('이미지는 PNG, JPG, GIF 파일만 업로드 가능합니다.');
      return;
    }

    if (type === 'video' && !allowedVideoTypes.includes(file.type)) {
      alert('영상은 MP4, AVI, MOV 파일만 업로드 가능합니다.');
      return;
    }

    setUploadedFiles(prev => ({
      ...prev,
      [type]: file
    }));
  };

  const handleFileInput = (e, type) => {
    const file = e.target.files[0];
    if (file) {
      handleFileUpload(file, type);
    }
  };

  const handleDrop = (e, type) => {
    e.preventDefault();
    setDragActive(prev => ({ ...prev, [type]: false }));
    
    const file = e.dataTransfer.files[0];
    if (file) {
      handleFileUpload(file, type);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDragEnter = (e, type) => {
    e.preventDefault();
    setDragActive(prev => ({ ...prev, [type]: true }));
  };

  const handleDragLeave = (e, type) => {
    e.preventDefault();
    setDragActive(prev => ({ ...prev, [type]: false }));
  };

  const removeFile = (type) => {
    setUploadedFiles(prev => ({
      ...prev,
      [type]: null
    }));
  };

  const handleReset = () => {
    setFormData({ linkUrl: '' });
    setUploadedFiles({ image: null, video: null });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.linkUrl.trim()) {
      alert('링크 URL을 입력해주세요.');
      return;
    }

    alert('콘텐츠가 성공적으로 등록되었습니다.');
    handleReset();
  };

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  return (
    <main className="customer-contents">
      <div className="page-header">
        <h1>고객 관리</h1>
        <p>고객 콘텐츠 관리</p>
      </div>

      <div className="content-section">
        <div className="section-header">
          <h2>콘텐츠 등록</h2>
          <p>새로운 콘텐츠를 등록하세요</p>
        </div>

        <form onSubmit={handleSubmit} className="contents-form">
          {/* 링크 URL */}
          <div className="form-group">
            <label htmlFor="linkUrl">링크 URL</label>
            <input
              type="url"
              id="linkUrl"
              placeholder="https://example.com"
              value={formData.linkUrl}
              onChange={handleInputChange}
              required
            />
          </div>

          {/* 파일 업로드 섹션 */}
          <div className="upload-section">
            <div className="upload-section-box">
              <div className="upload-header">
                <h3>사진 업로드</h3>
              </div>

              <div className="upload-container">
              {/* 이미지 업로드 */}
              <div className="upload-area">
                <input
                  type="file"
                  id="imageUpload"
                  accept="image/png,image/jpeg,image/jpg,image/gif"
                  onChange={(e) => handleFileInput(e, 'image')}
                  style={{ display: 'none' }}
                />
                <div
                  className={`upload-zone ${dragActive.image ? 'drag-active' : ''} ${uploadedFiles.image ? 'has-file' : ''}`}
                  onDrop={(e) => handleDrop(e, 'image')}
                  onDragOver={handleDragOver}
                  onDragEnter={(e) => handleDragEnter(e, 'image')}
                  onDragLeave={(e) => handleDragLeave(e, 'image')}
                  onClick={() => document.getElementById('imageUpload').click()}
                >
                  {uploadedFiles.image ? (
                    <div className="uploaded-file">
                      <div className="file-preview">
                        <img 
                          src={URL.createObjectURL(uploadedFiles.image)} 
                          alt="Preview" 
                          className="preview-image"
                        />
                      </div>
                      <div className="file-info">
                        <span className="file-name">{uploadedFiles.image.name}</span>
                        <span className="file-size">{formatFileSize(uploadedFiles.image.size)}</span>
                      </div>
                      <button
                        type="button"
                        className="remove-file"
                        onClick={(e) => {
                          e.stopPropagation();
                          removeFile('image');
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ) : (
                    <div className="upload-placeholder">
                      <div className="upload-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
                          <circle cx="9" cy="9" r="2"/>
                          <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
                        </svg>
                      </div>
                      <p className="upload-text">
                        <span className="highlight">클릭하여 업로드</span> 또는 드래그 앤 드롭
                      </p>
                      <p className="upload-types">PNG, JPG, GIF 파일 지원</p>
                    </div>
                  )}
                </div>
              </div>

            </div>
            </div>
            <div className="upload-section-box">
              <div className="upload-header">
                <span className="upload-limit">영상 업로드 (100MB 이하)</span>
              </div>
              <div className="upload-container">
                {/* 영상 업로드 */}
                <div className="upload-area">
                <input
                  type="file"
                  id="videoUpload"
                  accept="video/mp4,video/avi,video/mov"
                  onChange={(e) => handleFileInput(e, 'video')}
                  style={{ display: 'none' }}
                />
                <div
                  className={`upload-zone ${dragActive.video ? 'drag-active' : ''} ${uploadedFiles.video ? 'has-file' : ''}`}
                  onDrop={(e) => handleDrop(e, 'video')}
                  onDragOver={handleDragOver}
                  onDragEnter={(e) => handleDragEnter(e, 'video')}
                  onDragLeave={(e) => handleDragLeave(e, 'video')}
                  onClick={() => document.getElementById('videoUpload').click()}
                >
                  {uploadedFiles.video ? (
                    <div className="uploaded-file">
                      <div className="file-preview">
                        <div className="video-preview">
                          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                            <polygon points="23 7 16 12 23 17 23 7"/>
                            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                          </svg>
                        </div>
                      </div>
                      <div className="file-info">
                        <span className="file-name">{uploadedFiles.video.name}</span>
                        <span className="file-size">{formatFileSize(uploadedFiles.video.size)}</span>
                      </div>
                      <button
                        type="button"
                        className="remove-file"
                        onClick={(e) => {
                          e.stopPropagation();
                          removeFile('video');
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ) : (
                    <div className="upload-placeholder">
                      <div className="upload-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                          <polygon points="23 7 16 12 23 17 23 7"/>
                          <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
                        </svg>
                      </div>
                      <p className="upload-text">
                        <span className="highlight">클릭하여 업로드</span> 또는 드래그 앤 드롭
                      </p>
                      <p className="upload-types">MP4, AVI, MOV 파일 지원 (최대 100MB)</p>
                    </div>
                  )}
                </div>
                </div>
              </div>
            </div>
            
          </div>

          {/* 폼 액션 버튼들 */}
          <div className="form-actions">
            <button type="button" className="cancel-btn" onClick={handleReset}>
              취소
            </button>
            <button type="submit" className="submit-btn">
              콘텐츠 등록
            </button>
          </div>
        </form>
      </div>
    </main>
  );
};

export default CustomerContents; 